
enum AccountSettings {
    CaseSummarySidebar = 'caseSummarySidebar',
    EnableApplicationSectionEditing = 'enableApplicationSectionEditing',
    UWDecisionSection = 'uwDecisionSection',
    UWWorkbenchHiddenNotes = 'uwWorkbenchHiddenNotes',
    UWWorkbenchEditableNotes = 'uwWorkbenchEditableNotes',
    UWWorkbenchEditableNotesDuration = 'uwWorkbenchEditableNotesDuration',
    UWWorkbenchRequirementFirst = 'uwWorkbenchRequirementFirst',
    UWWorkbenchAttachmentFirst = 'uwWorkbenchAttachmentFirst',
    DisableInterviewRuleId = 'DisableInterviewRuleId',
    InterviewReadOnlyOnDisable = 'interviewReadOnlyOnDisable',
    PrefillQuestions = 'prefillQuestions',
    AddNoteForVariants = 'addNoteForVariants',
    EvidenceNotRequiredForManualRequirements = 'evidenceNotRequiredForManualRequirements',
    disabledNamedActions = 'DisableNamedActions',
    orphanRequirementTagExclusions = 'orphanRequirementTagExclusions',
    requirementTagExclusions = 'requirementTagExclusions',
    caseSummaryVersion2 = 'caseSummaryVersion2',
    autoReviewDocumentSetting = 'autoReviewDocumentSetting',
    autoCompleteRequirementSetting  = 'autoCompleteRequirementSetting',
    uwwCaseRequirementExcludedIntegrations = 'uwwCaseRequirementExcludedIntegrations',
    UWWorkbenchAutoAssignTasksOnAssignment = 'uwWorkbenchAutoAssignTasksOnAssignment',
    UWWorkbenchReassignTasksOnAssignment = 'uwWorkbenchReassignTasksOnAssignment',
    UWWorkbenchDuplicateTaskNotesInUWNotes = 'uwWorkbenchDuplicateTaskNotesInUWNotes',
    UWWorkbenchEnableTasks = 'uwWorkbenchEnableTasks',
    UWDecisionDisableUpdateRuleId = 'uwDecisionDisableUpdateRuleId'
}

export default AccountSettings;
